module.exports = __webpack_public_path__ + "static/media/slide-4.162d3f53.jpg";